module.exports = "/_next/static/images/6109e39b8fabe3536db8b90f2e5d50ac-pj-man-holding-business-card@0.75x.jpg";